import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const AnalyticsImage = props => (
    <SvgIcon viewBox="0 0 139 138" fill="none" {...props}>
        <path
            d="M28.3125 99.0938H9.4375C8.13445 99.0938 7.07812 100.15 7.07812 101.453V134.484C7.07812 135.787 8.13445 136.844 9.4375 136.844H28.3125C29.6155 136.844 30.6719 135.787 30.6719 134.484V101.453C30.6719 100.15 29.6155 99.0938 28.3125 99.0938Z"
            fill="#CADCEE"
        />
        <path
            d="M103.812 99.0938H84.9375C83.6345 99.0938 82.5781 100.15 82.5781 101.453V134.484C82.5781 135.787 83.6345 136.844 84.9375 136.844H103.812C105.116 136.844 106.172 135.787 106.172 134.484V101.453C106.172 100.15 105.116 99.0938 103.812 99.0938Z"
            fill="#CADCEE"
        />
        <path
            d="M66.0625 61.3438H47.1875C45.8845 61.3438 44.8281 62.4001 44.8281 63.7031V134.484C44.8281 135.787 45.8845 136.844 47.1875 136.844H66.0625C67.3655 136.844 68.4219 135.787 68.4219 134.484V63.7031C68.4219 62.4001 67.3655 61.3438 66.0625 61.3438Z"
            fill="#CADCEE"
        />
        <path
            d="M141.562 61.3438H122.688C121.384 61.3438 120.328 62.4001 120.328 63.7031V134.484C120.328 135.787 121.384 136.844 122.688 136.844H141.562C142.866 136.844 143.922 135.787 143.922 134.484V63.7031C143.922 62.4001 142.866 61.3438 141.562 61.3438Z"
            fill="#CADCEE"
        />
        <path
            d="M43.4124 35.8248L25.3656 53.8716C22.9199 52.2529 19.9602 51.6001 17.0605 52.04C14.1608 52.4798 11.5278 53.9809 9.67213 56.2521C7.81649 58.5233 6.87048 61.4027 7.01759 64.3319C7.1647 67.2611 8.39443 70.0312 10.4683 72.1051C12.5421 74.1789 15.3123 75.4087 18.2415 75.5558C21.1707 75.7029 24.0501 74.7569 26.3213 72.9012C28.5925 71.0456 30.0936 68.4126 30.5334 65.5129C30.9733 62.6132 30.3205 59.6535 28.7017 57.2078L46.7533 39.1656C45.4857 38.2175 44.3606 37.0924 43.4124 35.8248Z"
            fill="#CADCEE"
        />
        <path
            d="M56.625 37.75C63.1402 37.75 68.4219 32.4684 68.4219 25.9531C68.4219 19.4379 63.1402 14.1562 56.625 14.1562C50.1098 14.1562 44.8281 19.4379 44.8281 25.9531C44.8281 32.4684 50.1098 37.75 56.625 37.75Z"
            fill="#CADCEE"
        />
        <path
            d="M118.912 35.8248L100.866 53.8716C98.9417 52.5902 96.6818 51.9064 94.3702 51.9064C92.0587 51.9064 89.7987 52.5902 87.8749 53.8716L69.8375 35.8248C68.8893 37.0924 67.7642 38.2175 66.4966 39.1656L84.5434 57.2125C83.3647 58.99 82.6899 61.0537 82.5908 63.1842C82.4917 65.3147 82.9721 67.4322 83.9807 69.3114C84.9894 71.1906 86.4887 72.7612 88.319 73.8561C90.1493 74.951 92.2422 75.5292 94.375 75.5292C96.5077 75.5292 98.6006 74.951 100.431 73.8561C102.261 72.7612 103.761 71.1906 104.769 69.3114C105.778 67.4322 106.258 65.3147 106.159 63.1842C106.06 61.0537 105.385 58.99 104.206 57.2125L122.253 39.1656C120.986 38.2175 119.861 37.0924 118.912 35.8248Z"
            fill="#CADCEE"
        />
        <path
            d="M132.125 37.75C138.64 37.75 143.922 32.4684 143.922 25.9531C143.922 19.4379 138.64 14.1562 132.125 14.1562C125.61 14.1562 120.328 19.4379 120.328 25.9531C120.328 32.4684 125.61 37.75 132.125 37.75Z"
            fill="#CADCEE"
        />
    </SvgIcon>
);

export default AnalyticsImage;
